import axios from 'axios'
import config from '@/config'
// import store from '@/store'

export default {
  callBroker
}

var counter = 0
var requestsQueue = []
var url = config.app.webServerHostname + '/CallBroker.ashx'
var noRegion = {
  ConfirmBetSlipUsingConfirmations: 1
}

function Deferred () {
  // update 062115 for typeof
  if (typeof Promise !== 'undefined' && Promise.defer) {
    // need import of Promise.jsm for example: Cu.import('resource:/gree/modules/Promise.jsm');
    return Promise.defer()
  } else {
    /* A method to resolve the associated Promise with the value passed.
     * If the promise is already settled it does nothing.
     *
     * @param {anything} value : This value is used to resolve the promise
     * If the value is a Promise then the associated promise assumes the state
     * of Promise passed as value.
     */
    this.resolve = null

    /* A method to reject the assocaited Promise with the value passed.
     * If the promise is already settled it does nothing.
     *
     * @param {anything} reason: The reason for the rejection of the Promise.
     * Generally its an Error object. If however a Promise is passed, then the Promise
     * itself will be the reason for rejection no matter the state of the Promise.
     */
    this.reject = null

    /* A newly created Pomise object.
     * Initially in pending state.
     */
    this.promise = new Promise(function (resolve, reject) {
      this.resolve = resolve
      this.reject = reject
    }.bind(this))
    Object.freeze(this)
  }
}

function callBroker (serviceName, methodName, args) {
  // console.log('callBroker: ' + serviceName + ': ' + methodName)
  counter++
  // console.log('callBroker counter: ' + counter)

  var deferred
  if (args !== null) {
    args = args || {}
    if (!noRegion[methodName]) {
      args.IDMDRegion = config.app.region
    }
    args.IDMDLanguage = config.app.language
  } else {
    args = { }
  }

  var data = {
    'serviceName': serviceName,
    'methodName': methodName,
    'arguments': args
  }

  var pload = JSON.stringify(data)
  var matchingRequest = requestsQueue.filter(function (request) {
    return request.payload === pload
  })[0]

  if (!requestsQueue.length) {
    /*
     clearTimeout(timeoutCB)
     timeoutCB = setTimeout(function () {
     */
    setTimeout(function () {
      var requests = requestsQueue
      var payload = requests.map(function (request) {
        return {
          serviceName: request.data.serviceName,
          methodName: request.data.methodName,
          arguments: request.data.arguments
        }
      })
      requestsQueue = []
      // axios.post(url, payload)
      axios({
        method: 'post',
        url: url,
        data: payload,
        transformResponse: [function (data) {
          // Do whatever you want to transform the data
          return data && JSON.parse(data.replace(/\\>/g, '>').replace(/\\'/g, '\''))
        }]})
        .then(function (rpcResult) {
          if (rpcResult.data) {
            // if (typeof rpcResult.data === 'string') {
            //   rpcResult.data = JSON.parse(rpcResult.data.replace(/\\>/g, '>').replace(/\\'/g, '\''))
            // }
            rpcResult.data.forEach(function (response, index) {
              var request = requests[index]
              // response.request = request.data.arguments
              if (response.exceptionType) {
                if (response.exceptionType === 'Com.Finsoft.Warp.Connecticut.SessionTimeoutException' ||
                  response.exceptionType === 'Com.Finsoft.Warp.Connecticut.Services.UserNotLoggedInException' ||
                  response.exceptionType.indexOf('System.ServiceModel.FaultException') > -1) {
                  console.log('Callbroker exception: ' + response.exceptionType)
                  // doLogOut()
                }
                //
                return request.deferred.reject(response)
              } else {
                return request.deferred.resolve(response)
              }
            })
          }
        })
        .catch(function (error) {
          console.log(error)
          // return error
          deferred.reject(error)
        })
    }, 0)
  }

  if (matchingRequest) {
    deferred = matchingRequest.deferred
  } else {
    deferred = new Deferred()
    requestsQueue.push({
      data: data,
      counter: counter,
      payload: pload,
      deferred: deferred
    })
  }

  return deferred.promise
}



// WEBPACK FOOTER //
// ./src/library/rpcService/index.js